// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSection_heroSection__70WL7","container":"HeroSection_container__RH5Oy"};